import AppRedux from './app-redux';

export default AppRedux;